import React, { useEffect } from 'react'
import { clearAllBodyScrollLocks } from 'body-scroll-lock'
import styles from '@/styles/PickBox.module.scss'
import { RootState } from '@/app/store'
import { useSelector } from 'react-redux'

const Auth = ({ children, title }) => {
  const loginTypeStateSelector = useSelector(
    (loginTypeState: RootState) => loginTypeState.loginType.loginType
  )

  const datadataCampain = useSelector(
    (campainState: RootState) => campainState.campain.campaign
  )

  useEffect(() => {
    clearAllBodyScrollLocks()
  }, [])

  if (loginTypeStateSelector === 9) return <div>{''}</div>

  return (
    <section className="w-full">
      <div className={styles.c_auth_visual}>
        <img src={datadataCampain.image} alt="" />
      </div>
      <div className={`mx-2 sm:my-auto ${styles.c_auth_content}`}>
        <h1 className="text-gray-800 mt-5 text-center text-h2 font-bold">
          {title}
        </h1>
        <div className={styles.l_pickbox}>{children}</div>
      </div>
    </section>
  )
}

export default Auth
